import { createTheme } from "../utils/create-theme";
export var WEB_THEME = createTheme('web', {
  activeMode: 'light',
  light: {
    color: {
      textMid: '#969696',
      textTitle: '#0D0D0D',
      textSubtle: '#ABABAB',
      bold: '#000000',
      primary: '#FFCA04',
      // shapeable yellow
      secondary: '#333333',
      primaryVeryLight: '#FEE7B9',
      error: '#C52A39',
      subtleGrey: '#F5F5F5',
      // app chrome
      lineMid: '#D2D2D2',
      lineSemiSubtle: '#DADADA',
      lineSubtle: '#EEEEEE',
      // ---------------- DEPRECATED: Legacy Color Set ------------------>
      light: '#FFFFFF',
      dark: '#000000'
    }
  }
});